<template>
    <div
        class="image-node"
        :class="{'left': align == 'left', 'right': align == 'right'}"
        :style="{
            width: width,
            float: align
        }"
    >
        <img
            :src="src"
            :alt="alt"
            tabindex="-1"
            @keydown.delete="deleteNode"
            @keydown.escape="deleteNode"
        />

        <span class="node-actions">
            <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                <font-awesome-icon :icon="['far', 'edit']" />
            </b-btn>
            <b-btn size="sm" variant="danger" @click.prevent="deleteNode">
                <font-awesome-icon :icon="['fad', 'trash']" />
            </b-btn>
        </span>

        <ImageExtensionModal
            v-model="showImageModal"
            :view="view"
            :image="image"
            @save="save"
            @hide="showImageModal = false"
        />
    </div>
</template>

<script>
import ImageExtensionModal from "@/components/tiptap/extensions/ImageExtensionModal";
export default {
    name: "ImageExtensionView",
    components: {ImageExtensionModal},
    props: ['node', 'updateAttrs', 'view', 'getPos'],
    data:() => ({
        showImageModal: false,
    }),
    computed: {
        src: {
            get () {
                return this.node.attrs.src
            },
            set (src) {
                this.updateAttrs({
                    src
                })
            }
        },
        align: {
            get () {
                return this.node.attrs.align
            },
            set (align) {
                this.updateAttrs({
                    align
                })
            }
        },
        alt: {
            get () {
                return this.node.attrs.alt
            },
            set (alt) {
                this.updateAttrs({
                    alt
                })
            }
        },
        caption: {
            get () {
                if (this.node.attrs.caption) {
                    return this.node.attrs.caption
                } else {
                    return null
                }
            },
            set (caption) {
                this.updateAttrs({
                    caption
                })
            }
        },
        credit: {
            get () {
                if (this.node.attrs.credit) {
                    return this.node.attrs.credit
                } else {
                    return null
                }
            },
            set (credit) {
                this.updateAttrs({
                    credit
                })
            }
        },
        width: {
            get () {
                if (this.node.attrs.width) {
                    return this.node.attrs.width
                } else {
                    return null
                }
            },
            set (width) {
                this.updateAttrs({
                    width
                })
            }
        },
        style: {
            get () {
                if (this.node.attrs.style) {
                    return this.node.attrs.style
                } else {
                    return null
                }
            },
            set (style) {
                this.updateAttrs({
                    style
                })
            }
        },
        image () {
            let image = {}

            if (this.src) {
                image.src = this.src
            }

            if (this.width) {
                image.width = this.width
            }

            if (this.align) {
                image.align = this.align
            }

            if (this.alt) {
                image.alt = this.alt
            }

            if (this.caption) {
                image.caption = this.caption
            }

            if (this.credit) {
                image.credit = this.credit
            }

            return image
        }
    },

    methods: {
        edit() {
            this.showImageModal = true;
        },
        save ({src, width, align, caption, alt, credit}) {

            if (width)
                width = width + '%'

            if (src)
                this.updateAttrs({src});

            this.updateAttrs({width});

            this.updateAttrs({align});

            this.updateAttrs({caption});

            this.updateAttrs({alt});

            this.updateAttrs({credit});

            this.showImageModal = false;
        },
        deleteNode () {
            let tr = null
            let pos = this.getPos()

            if (this.view) {
                tr = this.view.state.tr
            }

            tr.delete(pos, pos + this.node.nodeSize)

            this.view.dispatch(tr)

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.image-node {
    display: inline-flex;
    position: relative;
    min-height: 50px;

    img {
        width: 100%;
        transition: ease .25s;
        margin-bottom: 1rem;
    }

    .caption {
        display: none;
    }

    .merlin-id {
        position: absolute;
        font-size: 80%;
        bottom: 1rem;
        left: 5px;
        background: white;
    }

    .node-actions {
        position: absolute;
        display: none;
        top: 10px;
        left: 10px;
        * + * {
            margin-left: .25rem;
        }
    }

    &.left {
        float: left;
        justify-content: flex-start;
        margin-right: 10px;
        .node-actions {
            left: 10px;
            right: auto;
        }
    }

    &.right {
        float: right;
        justify-content: flex-end;
        margin-left: 10px;
        .node-actions {
            left: auto;
            right: 10px;
        }
    }

    &:hover {
        img {
            filter: brightness(75%);
        }
        .node-actions {
            display: block;
        }
    }
}

</style>